export const HYDRATE_PHOTO_POSTS = 'HYDRATE_PHOTO_POSTS';
export const ADD_PHOTO_POST = 'ADD_PHOTO_POST';
export const ADD_PHOTO_POSTS = 'ADD_PHOTO_POSTS';
export const ADD_MULTI_PHOTO_POSTS = 'ADD_MULTI_PHOTO_POSTS';



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/photos/constants.es6